import AlertLevelTypes from 'store/actionTypes/alertLevel'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  system: []
}

const AlertLevel = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case AlertLevelTypes.GET_ALERT_LEVELS_SUCCESS:
      return {
        ...state,
        list: payload?.items || []
      }
    case AlertLevelTypes.GET_ALERT_LEVEL_DETAIL_SUCCESS:
      return {
        ...state,
        current: payload || []
      }
    case AlertLevelTypes.GET_SYSTEM_ALERT_LEVELS_SUCCESS:
      return {
        ...state,
        system: payload?.items || []
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default AlertLevel
